import { useTranslation } from 'react-i18next';

const articleClassName = 'text-mainWhite text-xl flex flex-col gap-5';
const boldParagraphClassName = 'font-bold';
const titleParagraphClassName = 'text-mainWhite font-bold text-2xl';

const HelpPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col px-8 my-10 gap-10">
      <p className={titleParagraphClassName}>Моите комплекси и игрища</p>
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Създаване на комплекс</p>
        <p>
          След кaто вече сте се регистрирали, можете да добавите комплекс от
          раздела “Моите комплекси” с клик на бутона “Създай комплекс”. Цялата
          информация ще бъде налична и за играчите от мобилното приложение и
          може по всяко време да бъде редактирана.
        </p>
      </article>
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Създаване на игрище</p>
        <p>
          След като имате комплекс, можете да добавите игрища към него от
          раздела “Моите комплекси” с клик на бутона “Добави игрище” към
          съответния комплекс. В полето “Избери комплекс” ще бъде автоматично
          избран комплексът. Ако желаете, можете да го смените. След като
          добавите първото си игрище към комплекса, в мобилното приложение на
          картата ще се покаже вашият комплекс заедно с неговите игрища.
        </p>
      </article>
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Преглед и редактиране на информация за комплекс
        </p>
        <p>
          Можете да видите информацията на комплекс с клик на бутона “Виж
          детайли”. Това ще ви отведе към страницата на комплекса. Тук ще видите
          снимките, които сте качили, адреса, който сте попълнили, информация за
          отговорника (Вас), услугите, които предоставя, и всички игрища
          добавени към комплекса. Бутонът “Редактирай” ще ви отведе към формата
          за редактиране на комплекс. “Време за отказване на резервация” –
          Резервация може да се прекрати не по-късно от въведения по ваша
          преценка брой часове преди началото на играта. В противен случай се
          дължи такса за наемане на игрището.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Редактиране и изтриване на игрище
        </p>
        <p>
          За да редактирате игрище, можете да го направите, като отидете на
          страницата на комплекса и кликнете върху бутона “Резервации” на
          желаното игрище. Това ще ви отведе към страницата на игрището, където
          ще видите бутон “Редактирай”. Той ще ви отведе към формата за
          редакция. Бутон “Изтрий” ще премахне игрището. “Направи игрището
          временно неизползваемо” ще забрани на играчите да го запазват, докато
          не се промени тази настройка.
        </p>
      </article>

      <p className={titleParagraphClassName}>Резервации</p>
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Управление на резервации</p>
        <p>
          След като сте създали комплекс с игрища, ще започнете да получавате
          заявки за резервация. Те ще идват под формата на известия. В
          страницата на игрището има таблица, която представлява календар с
          работната седмица на игрището. В него ще видите свободните и заетите
          часове. Можете да прегледате резервацията, като кликнете върху зает
          час.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Легенда на календара</p>
        <p className="whitespace-pre-line">
          {`Свободно - този час е свободен за резервация
           Заето - за този час има вече приета резервация и не може да се запазва
           В очакване - за този час има заявка за резервация. Докато не бъде отказана, този час е зает и не може да се запазва. Ако бъде одобрена, часът става в статус “Заето”.
           Анулирана - часът е бил зает от резервация “В очакване”, но е била пропусната да бъде приета или отказана на време.`}
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Приемане или отказване на резервация
        </p>
        <p>
          Кликнете върху резервация, която е “В очакване” и ще видите вдясно
          бутоните “Приеми” и “Откажи”.
        </p>
        <p>
          Можете да откажете резервации, които са в статус “Заето” и часът за
          тях не е минал. Кликнете върху час в “Заето” и след това кликнете
          върху бутона “Откажи”. Попълнете причина за отказа.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Раздел Резервации</p>
        <p>
          В раздел “Резервации” ще видите резервациите за текущия месец за
          всички игрища на даден комплекс. От тук също можете да одобрявате или
          отказвате резервации. Можете да видите и отказаните резервации. За
          ваше удобство, можете да филтрирате заявките по статус.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Запазване на игрище</p>
        <p>
          За да запазите игрище, отидете на страницата на игрището, което
          желаете да запазите, и кликнете на бутона “Резервирай”. С маркиране на
          полето “Запази за друг”, ще видите 2 полета, в които можете да
          въведете името и телефона на отговорника на резервацията.
        </p>
        <p>
          Ако маркирате полето „Многократна резервация“, ще можете да запазите
          игрището за избран час в продължение до 52 седмици. Изберете дните от
          седмицата, в които игрището ще бъде заето, и посочете начална дата на
          резервацията.
        </p>
      </article>

      <p className={titleParagraphClassName}>Настройки</p>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Основни</p>
        <p>
          Можете да редактирате данните си, като отидете в раздел “Настройки”. В
          подраздел “Основни”, кликенте върху един от бутоните “Промени”, за да
          ви се отвори формата за редактиране.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Моите комплекси</p>
        <p>
          В раздел “Настройки”, ако изберете подраздел “Моите комплекси” ще
          видите всичките си комплекси. От тук ще можете да управлявате и
          изтривате комплекси и игрища.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Отказ на резервация</p>
        <p>
          В подраздел “Отказ на резервация” ще можете да редактирате времето, до
          което ще е позволено отказването на резервация да се случва без такса.
        </p>
      </article>
    </div>
  );
};

export default HelpPage;
